/**
 * Generate a unique ID with a given prefix
 * @param {string} prefix - The prefix for the ID
 * @returns {string} A unique ID
 */
export const generateId = (prefix = '') => {
  const timestamp = new Date().getTime();
  const randomPart = Math.random().toString(36).substring(2, 10);
  return `${prefix}${timestamp}-${randomPart}`;
};

/**
 * Generate a UUID v4
 * @returns {string} A UUID v4 string
 */
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

/**
 * Generate a document ID
 * @returns {string} A UUID for document ID
 */
export const generateDocumentId = () => {
  // Return a proper UUID for document IDs since the database expects UUID type
  return generateUUID();
};

/**
 * Generate a signature ID
 * @returns {string} A UUID for signature ID
 */
export const generateSignatureId = () => {
  // Return a proper UUID for signature IDs since the database expects UUID type
  return generateUUID();
};

/**
 * Generate a field ID
 * @returns {string} A unique field ID
 */
export const generateFieldId = () => {
  return generateId('field_');
};

export default {
  generateId,
  generateDocumentId,
  generateSignatureId,
  generateFieldId,
};
